import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, of, throwError } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { Page } from './page/page';
import { State } from './state/state';
import { ApiService } from '../service/api.service';
import { Router } from '@angular/router';
import { AlertService } from '../service/alert.service';
import { MessageService } from '../service/message.service';
import { ConditionService } from '../service/condition.service';
var PageService = /** @class */ (function () {
    function PageService(router, logger, api, alertService, messageService, condService) {
        this.router = router;
        this.logger = logger;
        this.api = api;
        this.alertService = alertService;
        this.messageService = messageService;
        this.condService = condService;
        this.baseUrl = '/api/v1/page'; // URL to web api
        this._meta = new BehaviorSubject(new Page());
    }
    PageService.prototype.meta = function () {
        return this._meta;
    };
    PageService.prototype.getPage = function (flow, page) {
        var _this = this;
        if (flow === void 0) { flow = ''; }
        if (page === void 0) { page = ''; }
        if (flow === '' && page === '') {
            flow = this.current.flow;
            page = this.current.page;
        }
        this.logger.debug('page_store:', PageService.page_store);
        var h = PageService.page_store[flow];
        var meta;
        var url;
        if (page === '') {
            url = this.baseUrl + "/" + flow;
        }
        else {
            url = this.baseUrl + "/" + flow + "/" + page;
        }
        this.api.setErrorHandler(this.handleError());
        return this.api.get(url).pipe(map(function (data) { return _this.convertData(data, flow, page); }), finalize(function () { return _this.api.clearErrorHandler(); }));
    };
    PageService.prototype.getCurrentPageWithLang = function (lang) {
        var _this = this;
        var flow = this.current.flow;
        var page = this.current.page;
        var url;
        if (page === '') {
            url = this.baseUrl + "/" + flow;
        }
        else {
            url = this.baseUrl + "/" + flow + "/" + page;
        }
        this.api.setErrorHandler(this.handleError());
        return this.api.get(url, { query: JSON.stringify({ lang: lang }) }).pipe(map(function (data) { return _this.convertData(data, flow, page); }), finalize(function () { return _this.api.clearErrorHandler(); }));
    };
    PageService.prototype.convertData = function (data, flow, page) {
        if (data == null || this.api.getIsStop()) {
            return null;
        }
        var p = data;
        this.logger.debug('page:', p);
        p.state = { flow: flow, page: page };
        if (page === '') {
            PageService.page_store[flow] = p;
        }
        else {
            if (typeof PageService.page_store[flow] === 'undefined') {
                PageService.page_store[flow] = {};
            }
            PageService.page_store[flow][page] = p;
        }
        this.messageService.setMessage(p.messages);
        this._meta.next(p);
        this.current = new State();
        this.current.flow = flow;
        this.current.page = page;
        if (this.condService.getResetFlg()) {
            this.condService.resetCondition();
            this.condService.setResetFlg(false);
        }
        return p;
    };
    PageService.prototype.handleError = function () {
        var self = this;
        return function (error) {
            var errMsg;
            if (error instanceof HttpErrorResponse) {
                if (!self.api.checkBuildNo(error.headers)) {
                    return throwError('different BuildNo.');
                }
                if (error.status == 401) {
                    try {
                        errMsg = error.error;
                    }
                    catch (e) {
                    }
                    self.api.onUnauthorized(errMsg);
                    return of(null);
                }
            }
            else {
                errMsg = error.message ? error.message : error.toString();
            }
            return throwError(errMsg);
        };
    };
    PageService.page_store = {};
    PageService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PageService.ctorParameters = function () { return [
        { type: Router },
        { type: NGXLogger },
        { type: ApiService },
        { type: AlertService },
        { type: MessageService },
        { type: ConditionService }
    ]; };
    return PageService;
}());
export { PageService };
//# sourceMappingURL=page.service.js.map